<app-toolbar [title]="title"></app-toolbar>

<div class="container">
  <mat-card class="mat-elevation-z10">
    <div style="vertical-align: middle">
      <span class="material-icons && back-nav" routerLink="/login">navigate_before</span>
      <h1>Richiesta reset password</h1>
    </div>

    <mat-card-content fxLayout="column">

      <form class="form" [formGroup]="passwordChangeForm" (ngSubmit)="onSubmit(passwordChangeForm.value)">

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la tua email</mat-label>
          <input class="email-input" matInput placeholder="Email" formControlName="email" (focusin)="notFocused=false" (focusout)="notFocused=true">
          <ng-container *ngIf="passwordChangeForm.get('email').hasError('email') && notFocused">
            <div style="padding-top:15px">
            <span class="error">
             Inserisci un email valida
            </span>
            </div>
          </ng-container>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo codice fiscale</mat-label>
          <input matInput placeholder="Codice fiscale" formControlName="SSN" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <ng-container *ngIf="submitted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-container *ngIf="!show">
        <button mat-raised-button type="submit" color="primary"
                [disabled]="!passwordChangeForm.valid">Invia richiesta</button>
        </ng-container>

      </form>

    </mat-card-content>
  </mat-card>
</div>
